import i18n from 'i18next';

export const mapEnumToSelectOptions = (enumToMap, { i18nResource = '' } = {}) => {
  if (!enumToMap) return [];
  return Object.keys(enumToMap).map((key) => {
    const label = i18nResource ? i18n.t(`${i18nResource}.${key}`) : key;
    const value = enumToMap[key];
    return { value, label };
  });
};

export const overrideDefaultThreats = (patrolId, dictionaries, findingsList) =>
  findingsList.map((finding) => {
    const dictionary = dictionaries?.find((dict) => dict.key?.trim() === finding.label?.trim());
    return {
      ...finding,
      label: dictionary?.value ?? finding.label,
      overriden: !!dictionary,
    };
  });

export const chunkArray = (array, chunkSize) => {
  if (!array || !chunkSize) return [];

  return Array.from({ length: Math.ceil(array.length / chunkSize) }, (_, i) => array.slice(i * chunkSize, i * chunkSize + chunkSize));
};

export const mapClientCategoriesToSelectOptions = (clientCategories) => {
  if (!clientCategories || !clientCategories.length) return [];
  return clientCategories.map((category) => {
    const label = i18n.language === 'en' ? category.labelEn : category.labelFr;
    return { value: category.key, label };
  });
};
